import BaseService from '@/ecm/common/BaseService.js';

class VariableService {
    baseUrl = 'variables';

    create = (variable) => BaseService.post({ url: `${this.baseUrl}`, data: variable });
    update = (variable, id) => BaseService.put({ url: `${this.baseUrl}/${id}`, data: variable });
    invalidateCache = (id) => BaseService.post({ url: `${this.baseUrl}/invalidate-cache-basket/${id}` });
    delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
    get = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
    getGridData = (gridFilters) => BaseService.post({ url: `${this.baseUrl}/get-grid`, data: gridFilters });
    getForSearch = (variableType) => BaseService.get({ url: `${this.baseUrl}/for-search/${variableType}` });
    getValues = (variableCodes) => {
        const params = variableCodes.map(code => `variableCodes=${encodeURIComponent(code)}`).join('&');
        return BaseService.get({ url: `${this.baseUrl}/condition-values?${params}` });
    }
}

export default new VariableService();
